import ComponentsDemo from 'CustomModules/GlobalBPOCore/pages/ComponentsDemo/ComponentsDemo'
import HierarchyLookupType from 'CustomModules/GlobalBPOCore/pages/HierarchyLookupType/HierarchyLookupType'
import Report from 'CustomModules/GlobalBPOCore/pages/Report/Report'
import ShiftsManagement from 'CustomModules/GlobalBPOCore/pages/ShiftsManagement/ShiftsManagement'
import PasswordRecovery from 'CustomModules/GlobalBPOCore/pages/PasswordRecovery/PasswordRecovery'
import Evaluaciones from 'CustomModules/GlobalBPOCore/pages/Evaluaciones/Evaluaciones'
import EvaluacionesDesempeno from 'CustomModules/GlobalBPOCore/pages/Evaluaciones/Complemento/Desempeno'
import Login from 'CustomModules/GlobalBPOCore/pages/Login/Login'
import Requisiciones from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Requisiciones/Requisiciones'
import FormFillout from 'CustomModules/GlobalBPOCore/pages/Formularios/FormFillout'
import PazYSalvo from 'CustomModules/GlobalBPOCore/pages/GestionHumana/PazYSalvo/PazYSalvo'
import Main from 'CustomModules/GlobalBPOCore/Main'
import Reconocimiento from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Reconocimiento/Reconocimiento'
import Encuesta from 'CustomModules/GlobalBPOCore/pages/Encuesta/Encuesta'
import GReport from 'CustomModules/GlobalBPOCore/pages/GReport/GReport'
import WfRequest from 'CustomModules/GlobalBPOCore/pages/Nomina/WfRequest/WfRequest'
import ExtraWork from 'CustomModules/GlobalBPOCore/pages/Nomina/ExtraWork/ExtraWork'
import Viaticos from 'CustomModules/GlobalBPOCore/pages/Viaticos/Viaticos'
import Traslados from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Traslados/Traslados'
import Jobs from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Jobs/Jobs'
import ShiftSetupType from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Shift/ShiftSetupType'
import MantenimientoEvaluaciones from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Evaluaciones'
import Locations from 'CustomModules/GlobalBPOCore/pages/Viaticos/Locations'
import MantenimientoReport from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Greport/Report'
import ShiftSetup from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Shift/ShiftSetup'
import Coc from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Coc/Coc'
import Biodata from 'CustomModules/GlobalBPOCore/pages/Biodata/Biodata'
import Forms from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Form/Forms'
import ValadicXPuesto from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Valadic/ValadicXPuesto'
import ValadicXEmp from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/ValadicXEmp/ValadicXEmp'
import MantenimientoCompany from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Company/Company'
import MantenimientoItems from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Fmo/Items'
import MantenimientoInvoices from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Fmo/Invoices'
import Cc from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Cc/Cc'
import MantenimientoPolls from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Poll/Poll.vue'
import MantenimientoThird from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Third/Third'
import MantenimientoChartAccount from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Fmo/ChartAccount'
import MantenimientoWfRequest from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/WfRequest/WfRequest.vue'
import MantenimientoSeguridad from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/MantenimientoSeguridad.vue'
import EmpCoFvol from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/EmpCoFvol.vue'
import Frq from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Frq.vue'
import Overtime from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Overtime.vue'
import Lawsuits from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Lawsuits.vue'
import Absen from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Absen.vue'
import Benefits from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Benefits.vue'
import EmpPrepHealth from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/EmpPrepHealth.vue'
import EmpCoCespar from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/EmpCoCespar.vue'
import EmpDef from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/EmpDef.vue'
import Ocasionales from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Ocasionales'
import VacacionesHeader from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/VacacionesHeader'
import CreditosPrestamos from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/CreditosPrestamos'
import Analytics from 'CustomModules/GlobalBPOCore/pages/Analytics/Analytics'
import TabPlanoSs2388 from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/TabPlanoSs2388'
import Ctb from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/Ctb'
import Payroll from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/Payroll'
import DistVacConsultas from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/DistVacConsultas'
import SeguridadSocial from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadSocial/SeguridadSocial'
import Calendario from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Calendario/Calendario'
import Casos from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/Casos'
import CoLegal from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/CoLegal/CoLegal'
import StepsProcesoDisciplinario from 'CustomModules/GlobalBPOCore/pages/ReporteNovedad/StepsProcesoDisciplinario'
import Consultas from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/Consultas'
import Prorrogas from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Prorrogas/Prorrogas'
import CalendarioNomina from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/CalendarioNomina/CalendarioNomina'
import Bank from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Bank/Bank'
import Configuration from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Configuration/Configuration'
import LegalEntities from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/LegalEntities/LegalEntities'
import MantenimientoReportPDF from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Report/Report'
import ConceptosXEmpleado from 'CustomModules/GlobalBPOCore/pages/Reportes/ConceptosXEmpleado/ConceptosXEmpleado'
import Equivalency from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Equivalency/Equivalency'
import ReconocimientoAnual from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ReconocimientoAnual'
import CocCtb from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/CocCtb/CocCtb'
import Procesamiento from 'CustomModules/GlobalBPOCore/pages/Procesamiento/Procesamiento'
import AbsenType from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/AbsenType'
import MantenimientoCocNov from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Novedades/CocNov'
import NominaAbiertaYCerrada from 'CustomModules/GlobalBPOCore/pages/ConsultaNomina/NominaAbiertaYCerrada'
import DiasFestivos from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/DiasFestivos/DiasFestivos'
import DistributionCc from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/DistributionCc'
import Localidades from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Localidades/Localidades'
import MantenimientoCocRange from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Calendario/CocRange'
import MatrizSeguimiento from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/MatrizSeguimiento'
import Reincorporaciones from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/Reincorporaciones'
import EMO from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/EMO'
import OvertimeTurn from 'CustomModules/GlobalBPOCore/pages/OvertimeTurn/OvertimeTurn'
import Course from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/Course'
import MantenimientoActionGroups from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/ActionGroups/ActionGroups'
import EvaluacionesRequisiciones from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Requisiciones/EvaluacionesRequisiciones'
import DotacionEmpleado from 'CustomModules/GlobalBPOCore/pages/Dotaciones/ConsultaEmpleado'
import PDI from 'CustomModules/GlobalBPOCore/pages/PDI/PDI'
import MantenimientoRequisitionHierarchyCc from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Company/MantenimientoRequisitionHierarchyCc'
import InfoLaboral from 'CustomModules/GlobalBPOCore/pages/InfoLaboral/InfoLaboral'

// EMPLEADOS
import DynamicLoads from './pages/Mantenimiento/GDynamicLoads/DynamicLoads'
import DynamicLoad from './pages/DynamicLoads/DynamicLoad'
import EmployeeNavigation from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeNavigation.vue'
import PayrollManagement from './pages/Reportes/PayrollManagement/PayrollManagement'
import GenericTree from './pages/Mantenimiento/GenericTree/GenericTree'
import GlobalForms from './pages/GlobalForms/GlobalForms'
import GarmentTypeDot from './pages/Mantenimiento/Dotaciones/GarmentTypeDot'
import ParamPeaceSafe from './pages/Mantenimiento/PazYSalvo/ParamPeaceSafe'
import ConsultarFormFillOut from 'CustomModules/GlobalBPOCore/pages/Formularios/ConsultarFormFillOut'
import NomElectEstructuras from './pages/Mantenimiento/NomElect/NomElectEstructuras'

export const Override = {
  mainComponent: Main,
  loginComponent: Login
}

export const Routes = [
  // <editor-fold desc="Acciones">
  {
    path: 'comp_demo',
    name: 'Components Demo',
    component: ComponentsDemo
  },
  {
    path: 'master/list_of_values',
    name: 'list_of_values',
    component: HierarchyLookupType
  },
  {
    path: 'report',
    name: 'Report',
    component: Report
  },
  {
    path: 'shifts_managements',
    name: 'ShiftsManagement',
    component: ShiftsManagement
  },
  {
    path: 'eva',
    name: 'Evaluaciones',
    component: Evaluaciones
  },
  {
    path: 'requisiciones',
    name: 'Requisiciones',
    component: Requisiciones
  },
  {
    path: 'paz_y_salvo',
    name: 'PazYSalvo',
    component: PazYSalvo
  },
  {
    path: 'reconocimiento',
    name: 'Reconocimiento',
    component: Reconocimiento
  },
  {
    path: 'encuesta',
    name: 'Encuesta',
    component: Encuesta
  },
  {
    path: 'g_report',
    name: 'GReport',
    component: GReport
  },
  {
    path: 'wf_request',
    name: 'WfRequest',
    component: WfRequest
  },
  {
    path: 'extra_work',
    name: 'ExtraWork',
    component: ExtraWork
  },
  {
    path: 'viaticos',
    name: 'Viaticos',
    component: Viaticos
  },
  {
    path: 'traslados',
    name: 'Traslados',
    component: Traslados
  },
  {
    path: 'mantenimiento/jobs',
    name: 'Jobs',
    component: Jobs
  },
  {
    path: 'shiftsetuptype',
    name: 'shiftsetuptype',
    component: ShiftSetupType
  },
  {
    path: 'mantenimiento/evaluaciones',
    name: 'MantenimientoEvaluaciones',
    component: MantenimientoEvaluaciones
  },
  {
    path: 'form_fillout',
    name: 'FormFillout',
    component: FormFillout
  },
  {
    path: 'locations',
    name: 'Locations',
    component: Locations
  },
  {
    path: 'mantenimiento/report',
    name: 'mantenimientoreport',
    component: MantenimientoReport
  },
  {
    path: 'mantenimiento/shift_setup',
    name: 'ShiftSetup',
    component: ShiftSetup
  },
  {
    path: 'mantenimiento/coc',
    name: 'Coc',
    component: Coc
  },
  {
    path: 'biodata',
    name: 'Biodata',
    component: Biodata
  },
  {
    path: 'mantenimiento/forms',
    name: 'formes',
    component: Forms
  },
  {
    path: 'mantenimiento/valadic_puesto',
    name: 'valadic_puesto',
    component: ValadicXPuesto
  },
  {
    path: 'mantenimiento/valadicxemp',
    name: 'valadicxemp',
    component: ValadicXEmp
  },
  {
    path: 'mantenimiento/fmo/items',
    name: 'mantenimiento_fmo_items',
    component: MantenimientoItems
  },
  {
    path: 'mantenimiento/fmo/invoices',
    name: 'mantenimiento_fmo_invoices',
    component: MantenimientoInvoices
  },
  {
    path: 'mantenimiento/third',
    name: 'mantenimiento_third',
    component: MantenimientoThird
  },
  {
    path: 'mantenimiento/cuenta_contable',
    name: 'mantenimiento_cuenta_contable',
    component: MantenimientoChartAccount
  },
  {
    path: 'mantenimiento/poll',
    name: 'mantenimientopolls',
    component: MantenimientoPolls
  },
  {
    path: 'mantenimiento/cc',
    name: 'cc',
    component: Cc
  },
  {
    path: 'mantenimiento/wfrequest',
    name: 'mantenimientowfrequest',
    component: MantenimientoWfRequest
  },
  {
    path: 'mantenimiento/seguridad',
    name: 'mantenimientouser',
    component: MantenimientoSeguridad
  },
  {
    path: 'mantenimiento/company',
    name: 'mantenimiento_company',
    component: MantenimientoCompany
  },
  {
    path: 'employee',
    name: 'employee_navigation',
    component: EmployeeNavigation
  },
  {
    path: 'novedades/aportesvolyafc',
    name: 'emp_co_fvol',
    component: EmpCoFvol
  },
  {
    path: 'novedades/fijas',
    name: 'frq',
    component: Frq
  },
  {
    path: 'novedades/tiempo',
    name: 'overtime',
    component: Overtime
  },
  {
    path: 'novedades/embargos',
    name: 'lawsuits',
    component: Lawsuits
  },
  {
    path: 'novedades/ausentismos',
    name: 'absen',
    component: Absen
  },
  {
    path: 'novedades/auxilios',
    name: 'benefits',
    component: Benefits
  },
  {
    path: 'novedades/medicinaprep',
    name: 'empprephealth',
    component: EmpPrepHealth
  },
  {
    path: 'novedades/antcesantias',
    name: 'empcocespar',
    component: EmpCoCespar
  },
  {
    path: 'novedades/liqdefinitiva',
    name: 'empdef',
    component: EmpDef
  },
  {
    path: 'novedades/ocasionales',
    name: 'novedades_ocasionales',
    component: Ocasionales
  },
  {
    path: 'novedades/vacaciones',
    name: 'novedades_vacaciones',
    component: VacacionesHeader
  },
  {
    path: 'novedades/credito',
    name: 'novedades_credito',
    component: CreditosPrestamos
  },
  {
    path: 'analytics',
    name: 'analytics',
    component: Analytics
  },
  {
    path: 'consultas/plano_ss_2388',
    name: 'consultas_plano_ss_2388',
    component: TabPlanoSs2388
  },
  {
    path: 'consultas/contabilidad',
    name: 'consultas_contabilidad',
    component: Ctb
  },
  {
    path: 'consultas/acumulados',
    name: 'consultas_acumulados',
    component: Payroll
  },
  {
    path: 'consultas/vacaciones',
    name: 'vacaciones',
    component: DistVacConsultas
  },
  {
    path: 'gestion_humana/seguridad_social',
    name: 'seguridad_social',
    component: SeguridadSocial
  },
  {
    path: 'seguridadysalud/consulta',
    name: 'consultas',
    component: Consultas
  },
  {
    path: 'seguridadysalud/casos',
    name: 'seguridadysalud',
    component: Casos
  },
  {
    path: 'mantenimiento/parametros_de_ley',
    name: 'parametros_de_ley',
    component: CoLegal
  },
  {
    path: 'mantenimiento/calendario',
    name: 'calendario',
    component: Calendario
  },
  {
    path: 'gestion_humana/prorrogas',
    name: 'prorrogas',
    component: Prorrogas
  },
  {
    path: 'mantenimiento/calendario_nomina',
    name: 'calendario_nomina',
    component: CalendarioNomina
  },
  {
    path: 'mantenimiento/bancos',
    name: 'banco',
    component: Bank
  },
  {
    path: 'mantenimiento/configuracion',
    name: 'configuracion',
    component: Configuration
  },
  {
    path: 'mantenimiento/dynamic_loads',
    name: 'dynamic_loads',
    component: DynamicLoads
  },
  {
    path: 'mantenimiento/entidades',
    name: 'entidades',
    component: LegalEntities
  },
  {
    path: 'reportes/payroll_management',
    name: 'payroll_management',
    component: PayrollManagement
  },
  {
    path: 'mantenimiento/equivalencia',
    name: 'mantenimiento_equivalencia',
    component: Equivalency
  },
  {
    path: 'reportes/nomina_abierta',
    name: 'reportes_nomina_abierta',
    component: ConceptosXEmpleado
  },
  {
    path: 'mantenimiento/reportes_html_ireport',
    name: 'reportes',
    component: MantenimientoReportPDF
  },
  {
    path: 'mantenimiento/contabilidad',
    name: 'mantenimiento_contabilidad',
    component: CocCtb
  },
  {
    path: 'reporte_novedad/proceso_disciplinario',
    name: 'reporte_novedad',
    component: StepsProcesoDisciplinario
  },
  {
    path: 'reconocimiento_anual',
    name: 'reconocimiento_anual',
    component: ReconocimientoAnual
  },
  {
    path: 'procesamiento',
    name: 'procesamiento',
    component: Procesamiento
  },
  {
    path: 'mantenimiento/tipo_ausentismo',
    name: 'mantenimiento/tipo_ausentismo',
    component: AbsenType
  },
  {
    path: 'consultas/nomina_abierta_cerrada',
    name: 'nomina_abierta_cerrada',
    component: NominaAbiertaYCerrada
  },
  {
    path: 'mantenimiento/dias_festivos',
    name: 'dias_festivos',
    component: DiasFestivos
  },
  {
    path: 'mantenimiento/coc_range',
    name: 'mantenimiento/coc_range',
    component: MantenimientoCocRange
  },
  {
    path: 'mantenimiento/localidades',
    name: 'localidades',
    component: Localidades
  },
  {
    path: 'mantenimiento/coc_nov',
    name: 'mantenimiento/coc_nov',
    component: MantenimientoCocNov
  },
  {
    path: 'novedades/distribution_cc',
    name: 'novedades/distribution_cc',
    component: DistributionCc
  },
  {
    path: 'seguimiento/incapacidades',
    name: 'seguimiento/incapacidades',
    component: MatrizSeguimiento
  },
  {
    path: 'seguimiento/reincorporaciones',
    name: 'seguimiento/reincorporaciones',
    component: Reincorporaciones
  },
  {
    path: 'mantenimiento/generic_tree',
    name: 'GenericTree',
    component: GenericTree
  },
  {
    path: 'seguimiento/emo',
    name: 'seguimiento/emo',
    component: EMO
  },
  // </editor-fold>
  {
    path: 'seguimiento/turnos',
    name: 'seguimiento/turnos',
    component: OvertimeTurn
  },
  {
    path: 'dynamic_loads',
    name: 'dynamic_loads',
    component: DynamicLoad
  },
  {
    path: 'cursos',
    name: 'Cursos',
    component: Course
  },
  {
    path: 'mantenimiento/action_groups',
    name: 'action_groups',
    component: MantenimientoActionGroups
  },
  {
    path: 'global_forms',
    name: 'global_forms',
    component: GlobalForms
  },
  {
    path: 'evaluaciones_requisiciones',
    name: 'evaluaciones_requisiciones',
    component: EvaluacionesRequisiciones
  },
  {
    path: 'seguridadysalud/dotacion',
    name: 'dotaciones',
    component: DotacionEmpleado
  },
  {
    path: 'mantenimiento/dotacion',
    name: 'dotaciones',
    component: GarmentTypeDot
  },
  {
    path: 'mantenimiento/pazysalvo',
    name: 'pazysalvo',
    component: ParamPeaceSafe
  },
  {
    path: 'pdi',
    name: 'pdi',
    component: PDI
  },
  {
    path: 'mantenimiento/aprobador_x_cc_ss',
    name: 'mantenimiento_aprobador_x_cc_ss',
    component: MantenimientoRequisitionHierarchyCc
  },
  {
    path: 'consultar_form_fillout',
    name: 'ConsultarFormFillout',
    component: ConsultarFormFillOut
  },
  {
    path: 'mantenimiento/nomina_electronica',
    name: 'estructuras',
    component: NomElectEstructuras
  },
  {
    path: 'eva_comple',
    name: 'Desempeno',
    component: EvaluacionesDesempeno
  }
]

export const GlobalRoutes = [
  {
    path: '/password_recovery',
    name: 'Password Recovery',
    component: PasswordRecovery
  },
  {
    path: '/working_information/:tipocertificado/:identificacion/:consecutivo',
    name: 'Working Information',
    component: InfoLaboral
  },
  {
    path: '/working_information',
    name: 'Working Information',
    component: InfoLaboral
  }
]

export const PublicRoutes = ['Password Recovery', 'Working Information']



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/routes.js